const angular = require('angular');
const { some, startsWith } = require('lodash');
const SmartBanner = require('smart-app-banner');

module.exports = function ($rootScope, $state, shopperService, loginService, pageMetadataService, memoScroll, moveFocus, analyticsService, settings, $window) {
    function promptForLogin(event, toState, toParams) {
        event.preventDefault();
        loginService.promptForLogin(loginService.LoginToContinueMessage, toState, toParams);
    }

    $rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState, fromParams) => {


        // this condition does not checkout the direct land on this homepage, Trader is already taking care about that,
        // this is only when the user is navigating with the spa.
        // we should have a checkout to whether the user is logged in to content management, but this flag does not exist on the front end, so
        // we had to add  fromState.name !== '' instead that check if leave to Trader to design which angular version to service for direct landing.
        if (settings.frontendManagement && settings.frontendManagement.useAngular2PlusHomepage && toState.name === 'root' && fromState.name !== '') {
            event.preventDefault();
            $window.location.assign('/'); // Go from this SPA to the Angular2+ SPA
        }

        if (fromState.data && fromState.data.onAuthReturnToState) {
            $rootScope.onAuthRedirectedState = $state.get(fromState.data.onAuthReturnToState);
            $rootScope.onAuthRedirectedStateParams = {};
        } else {
            $rootScope.onAuthRedirectedState = fromState;
            $rootScope.onAuthRedirectedStateParams = fromParams;
        }

        if (toState.data && toState.data.authenticate && shopperService.IsGuest) {
            if (angular.isArray(toState.data.authenticate)) {
                $state.shouldAuthenticate(toState, toParams).then((requiresLogin) => {
                    if (requiresLogin) {
                        promptForLogin(event, toState, toParams);
                    }
                });
            } else {
                promptForLogin(event, toState, toParams);
            }
        }
    });

    $rootScope.$on('$stateChangeSuccess', () => {
        pageMetadataService.useCurrentStateMetadata();

        moveFocus('#body-container', true);
        moveFocus(() => $('#center-panel h1').filter(':first'), false);
    });

    $rootScope.$on('$locationChangeStart', (event, newUrl, oldUrl) => {
        memoScroll.rememberScrollPosition(oldUrl);
    });

    $rootScope.$on('$locationChangeSuccess', (event, newUrl, oldUrl = '') => {
        // Only restore the scroll position if the path has changed. This is to prevent
        // jarring scroll position changes when changing sort by options/product filters.
        const hasPathChanged = newUrl.split('?')[0] !== oldUrl.split('?')[0];

        if (!($state.current && $state.current.data && $state.current.data.optOutOfScrollRestore) && (hasPathChanged || ($state.current && $state.current.reloadOnSearch))) {
            memoScroll.restoreScrollPosition(newUrl);
        }
    });

    $rootScope.$on('$stateChangeSuccess', (event, state) => {
        if (state.name === 'root') {
            analyticsService.push({ type: analyticsService.mapperTypes.content.general, data: { page: 'root' } });
        }

        if (state.name === 'shop.page') {
            analyticsService.push({ type: analyticsService.mapperTypes.content.general });
        }

        if (startsWith(state.name, 'shop.authentication')) {
            analyticsService.push({
                data: { 'page.Type': 'account' },
                type: analyticsService.mapperTypes.content.general,
            });
        }

        if (state.name === 'shop.recipes') {
            analyticsService.push({
                data: { 'page.Type': 'content' },
                type: analyticsService.mapperTypes.content.general,
            });
        }

        if (state.name === 'shop.recipes.noSavedRecipes') {
            analyticsService.push({
                data: { recipes: {} },
                type: analyticsService.mapperTypes.content.recipeCategory,
            });
        }

        if (state.name === 'shop.recipes.recipenotfound') {
            analyticsService.push({
                data: { recipes: {} },
                type: analyticsService.mapperTypes.content.recipeCategory,
            });
        }

        if (state.name === 'shop.list') {
            analyticsService.push({
                data: {
                    'page.Type': 'content',
                    'page.TypeVariation': shopperService.IsGuest ? 'Guest' : 'Logged in',
                },
                type: analyticsService.mapperTypes.content.general,
            });
        }
        // define other page type tealium push on route change for e.g. /shop/embedded/new-app
        if (state.name) {
            const pageTypeExceptions = settings.analytics.tealiumPageTypeExceptions;
            if (!some(pageTypeExceptions, ex => startsWith(state.name, ex))) {
                analyticsService.push({
                    data: { 'page.Type': 'other' },
                    type: analyticsService.mapperTypes.content.general,
                });
            }
        }
    });

    if (settings.smartBanner.enableSmartBanner === true) {
        // eslint-disable-next-line no-new
        new SmartBanner({
            daysHidden: settings.smartBanner.daysHiddenAfterClose,
            daysReminder: settings.smartBanner.daysHiddenAfterView,
            title: settings.smartBanner.title,
            appStoreLanguage: 'us',
            author: settings.smartBanner.author,
            button: 'VIEW',
            store: {
                ios: settings.smartBanner.appleStore,
                android: settings.smartBanner.googleStore,
            },
            price: {
                ios: 'FREE',
                android: 'FREE',
            },
        });

        $rootScope.$on('$stateChangeSuccess', () => {
            if (document.querySelector("meta[name='apple-itunes-app']") === null) {
                return;
            }

            angular
                .element(document.querySelector("meta[name='apple-itunes-app']"))
                .attr('app-argument', $state.href($state.current.name, $state.params, { absolute: true }));
        });
    }
};



// WEBPACK FOOTER //
// ./src/configuration/startup.js